import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiheaderService } from './apiheader.service';
import { URLPaths } from '../utilities/urlPaths.config';

@Injectable({
  providedIn: 'root'
})
export class TransportModeService {
  private _modesCache: any[] | null = null;

  constructor(private http: HttpClient) {}

  getTransportModes(): Observable<any[]> {
    if (this._modesCache && this._modesCache.length > 0) {
      return of(this._modesCache);
    }
    return this.http.get<any[]>(
      URLPaths.URL_TRANSPORT_MODES,
      { headers: ApiheaderService.getHeaders() }
    ).pipe(
      tap(modes => {
        if (modes && modes.length > 0) {
          this._modesCache = modes;
        }
      })
    );
  }
}
